import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'
import { useToast } from '@chakra-ui/react'
import { useMutation, useQueryClient } from 'react-query'
import { LINK_FORMS } from '../constants'
import { LinkFormInput } from '../types'
import { transformLinkFormInput } from '../utils'

const updateLinkForm = async ({
  form,
  id,
}: {
  form: LinkFormInput
  id: number
}) => {
  await fetchAPI({
    method: 'put',
    path: `/forms/${id}`,
    data: transformLinkFormInput(form),
  })
}

export const useUpdateLinkForm = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(updateLinkForm, {
    onSuccess: async () => {
      await queryClient.refetchQueries([LINK_FORMS])

      toast({
        description: t('views.admin.forms.services.update_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
